import { Transition } from "@headlessui/react"
import { Form, Head } from "@inertiajs/react"

import HeadingSmall from "@/components/heading-small"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import type { BreadcrumbItem } from "@/types"
import type { SettingsMessagingPrivaciesShow } from "@/types/serializers"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Privacidad de mensajes",
    href: "/configuracion/privacidad-mensajes",
  },
]

const privacyOptions = [
  {
    value: "todos",
    label: "Todos",
    description: "Cualquier usuario puede enviarte mensajes",
  },
  {
    value: "seguidores",
    label: "Seguidores",
    description: "Solo quienes te siguen pueden enviarte mensajes",
  },
  {
    value: "scouts_verificados",
    label: "Scouts verificados",
    description: "Solo scouts verificados y clubes pueden contactarte",
  },
  {
    value: "nadie",
    label: "Nadie",
    description: "Nadie puede enviarte mensajes directos",
  },
]

export default function MessagingPrivacyShow({
  messaging_privacy,
}: SettingsMessagingPrivaciesShow) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Privacidad de mensajes" />

      <SettingsLayout>
        <div className="space-y-6">
          <HeadingSmall
            title="Privacidad de mensajes"
            description="Elegí quién puede enviarte mensajes directos"
          />

          <Form
            method="patch"
            action="/configuracion/privacidad-mensajes"
            options={{
              preserveScroll: true,
            }}
            className="space-y-6"
          >
            {({ processing, recentlySuccessful }) => (
              <>
                <div className="grid gap-2">
                  <Label htmlFor="messaging_privacy">
                    Quién puede enviarte mensajes
                  </Label>
                  <input
                    type="hidden"
                    name="player_profile[messaging_privacy]"
                    id="messaging_privacy_hidden"
                  />
                  <Select
                    name="player_profile[messaging_privacy]"
                    defaultValue={messaging_privacy}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Seleccionar" />
                    </SelectTrigger>
                    <SelectContent>
                      {privacyOptions.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                          <div>
                            <div>{option.label}</div>
                            <div className="text-muted-foreground text-xs">
                              {option.description}
                            </div>
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex items-center gap-4">
                  <Button disabled={processing}>Guardar</Button>

                  <Transition
                    show={recentlySuccessful}
                    enter="transition ease-in-out"
                    enterFrom="opacity-0"
                    leave="transition ease-in-out"
                    leaveTo="opacity-0"
                  >
                    <p className="text-muted-foreground text-sm">Guardado</p>
                  </Transition>
                </div>
              </>
            )}
          </Form>
        </div>
      </SettingsLayout>
    </AppLayout>
  )
}
